export default {
  SMS: 'SMS',
  WhatsApp: 'WhatsApp',
  Email: 'Email'
}